import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { ReactComponent as PPGEEIcon } from '../images/ppgee.svg';
import { ReactComponent as LatesIcon } from '../images/lates.svg';
import * as Data from '../Data';
import './Login.css';

interface LoginProps {
  onLoginSuccess: (token: string, username: string) => void;
}

export const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      setErrorMessage('Por favor, informe o usuário e a senha.');
      return;
    }

    setLoading(true);
    setErrorMessage(null);

    try {
      const auth = await Data.login(username.trim(), password);
      onLoginSuccess(auth.access, auth.username);
    } catch (err: any) {
      console.error('Erro de login:', err);
      if (err.response) {
        if (err.response.status === 401) {
          setErrorMessage('Credenciais inválidas. Verifique o usuário e a senha.');
        } else if (err.response.status === 400) {
          setErrorMessage('Dados de login inválidos. Preencha todos os campos.');
        } else {
          setErrorMessage(`Erro no servidor (${err.response.status}). Tente novamente.`);
        }
      } else if (err.request) {
        setErrorMessage('Não foi possível conectar à API. Verifique sua conexão.');
      } else {
        setErrorMessage('Erro ao tentar autenticar. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logos">
            <LatesIcon width={110} height={32} />
            <PPGEEIcon width={110} height={32} />
          </div>
          <h1 className="login-title">MAI/DAI - Green Power</h1>
          <p className="login-subtitle">Monitoramento de Eletrolizadores</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {errorMessage && (
            <div className="login-error">
              <i className="pi pi-exclamation-circle" />
              <span>{errorMessage}</span>
            </div>
          )}

          <div className="login-field">
            <label htmlFor="username">Usuário</label>
            <div className="login-input-wrapper">
              <i className="pi pi-user" />
              <InputText
                id="username"
                value={username}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                placeholder="Digite seu usuário"
                disabled={loading}
                autoFocus
                autoComplete="username"
              />
            </div>
          </div>

          <div className="login-field">
            <label htmlFor="password">Senha</label>
            <div className="login-input-wrapper">
              <i className="pi pi-lock" />
              <Password
                inputId="password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                feedback={false}
                toggleMask
                disabled={loading}
                autoComplete="current-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            label={loading ? 'Autenticando...' : 'Entrar no Sistema'}
            icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'}
            className="login-button"
            disabled={loading}
          />
        </form>

        <div className="login-footer">
          Acesso restrito a operadores e pesquisadores cadastrados.
        </div>
      </div>
    </div>
  );
};

export default Login;
